<template>
  <div class="fixed bottom-24 right-2 w-[88px] h-40 rounded-[300px] bg-[#2044FE] cursor-pointer">
    <div class="group w-full h-full flex flex-col justify-center items-center relative">
      <img
        class="w-12 h-12 mb-2"
        src="~/assets/imgs/common/qrcode.png"
      >
      <div class="w-full text-center text-white text-[12px] leading-[18px]">
        扫码关注
        <br>
        官方公众号
      </div>
      <div
        class="invisible group-hover:visible p-5 rounded-[20px] bg-white shadow-xl absolute right-[98px]"
      >
        <div class="w-28 h-28">
          <img
            class="w-full h-full"
            src="~/assets/imgs/common/wx-qrcode.png"
          >
        </div>

        <div class="w-full text-center text-[#333333] text-[12px] leading-[18px]">
          微信扫一扫
          <br>
          关注官方公众号
        </div>
      </div>
    </div>
  </div>
</template>
